// A history entry can carry opt-in to details, but a reload starts concealed.
// This is transient presentation state; the server separately requires Admin.
const session=crypto.randomUUID();
export const patchAdminViewKey=scope=>JSON.stringify([session,scope]);
